module.exports = __webpack_public_path__ + "static/media/Capacidad-media.1e85e63f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/Capacidad-media.svg
// module id = 147
// module chunks = 0